// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/quality-control/${file}.vue`);

export default [
  // Complaints
  {
    path: "/quality-control/complaints",
    name: "complaints-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "QualityControlComplaints",
    },
    components: {
      content: lazyLoad("complaint-list"),
    },
  },
  {
    path: "/quality-control/complaints/create*",
    name: "complaints-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "QualityControlComplaints",
    },
    components: {
      content: lazyLoad("complaint-detail"),
    },
  },
  {
    path: "/quality-control/complaints/edit/:id*",
    name: "complaints-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "QualityControlComplaints",
    },
    components: {
      content: lazyLoad("complaint-detail"),
    },
  },
  {
    path: "/quality-control/complaints/review/:id*",
    name: "complaints-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "QualityControlComplaints",
    },
    components: {
      content: lazyLoad("complaint-detail"),
    },
  },
];
